<template>
  <div>
    <closing-analysis
      :submit-closing-analysis="submitClosingAnalysis"
      :get-compensatory-request-analysis-data="
        getCompensatoryRequestAnalysisData
      "
      :get-compensatory-request-replacement-strategies="
        getCompensatoryRequestReplacementStrategies
      "
      :get-compensatory-document-types="getCompensatoryDocumentTypes"
      :replacement-document-upload="replacementDocumentUpload"
      :delete-compensatory-document="deleteCompensatoryDocument"
      :complete-replacement="completeReplacement"
      :download-document-by-attachment-id="downloadDocumentByAttachmentId"
      :get-compensatory-request-replacement-comments-strategies="
        getCompensatoryRequestReplacementCommentsStrategies
      "
      :get-compensatory-approvement-reasons="getCompensatoryApprovementReasons"
      :reset-replacement="resetReplacement"
      :view-reset-status-action="hasResetPermission"
    />
  </div>
</template>

<script>
import { ClosingAnalysis } from "compensatory-service";
import {
  submitClosingAnalysis as _submitClosingAnalysis,
  getCompensatoryRequestAnalysisData as _getCompensatoryRequestAnalysisData,
  getCompensatoryRequestReplacementStrategies as _getCompensatoryRequestReplacementStrategies,
  getCompensatoryDocumentTypes as _getCompensatoryDocumentTypes,
  replacementDocumentUpload as _replacementDocumentUpload,
  deleteCompensatoryDocument as _deleteCompensatoryDocument,
  completeReplacement as _completeReplacement,
  resetReplacement as _resetReplacement,
  getCompensatoryRequestReplacementCommentsStrategies as _getCompensatoryRequestReplacementCommentsStrategies,
  getCompensatoryApprovementReasons as _getCompensatoryApprovementReasons
} from "@/modules/compensatory-service/api";
import peiServices from "@/services/pei/general";
import store from "@/store/index";
export default {
  components: {
    ClosingAnalysis
  },
  data() {
    return {};
  },
  methods: {
    submitClosingAnalysis(id) {
      return _submitClosingAnalysis(id);
    },
    getCompensatoryRequestAnalysisData(id) {
      return _getCompensatoryRequestAnalysisData(id);
    },
    getCompensatoryRequestReplacementStrategies(replacementId) {
      return _getCompensatoryRequestReplacementStrategies(replacementId);
    },
    getCompensatoryDocumentTypes(requestId) {
      return _getCompensatoryDocumentTypes(requestId);
    },
    replacementDocumentUpload(params) {
      return _replacementDocumentUpload(params);
    },
    deleteCompensatoryDocument(params) {
      return _deleteCompensatoryDocument(params);
    },
    completeReplacement(payload) {
      return _completeReplacement(payload);
    },
    resetReplacement(replacementId) {
      return _resetReplacement(replacementId);
    },
    downloadDocumentByAttachmentId(documentId) {
      return peiServices.downloadDocumentByAttachmentId(documentId);
    },
    getCompensatoryRequestReplacementCommentsStrategies(replacementId) {
      return _getCompensatoryRequestReplacementCommentsStrategies(
        replacementId
      );
    },
    getCompensatoryApprovementReasons() {
      return _getCompensatoryApprovementReasons();
    }
  },
  computed: {
    hasResetPermission() {
      return store.getters.HasPermission(
        "compensatoryservice.resetReplacement"
      );
    }
  }
};
</script>

<style scoped></style>
